import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Button, Card, CardHeader, CardBody } from "reactstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import the styles
import { helper } from "lib/helper";
import adminModel from "models/admin.model";

const TermsAndConditionsPage = () => {
  const [termsContent, setTermsContent] = useState("");
  const [conditionsContent, setConditionsContent] = useState("");
  const [currentFormats, setCurrentFormats] = useState({});
  const quillRef = useRef(null); // Reference to the ReactQuill instance


  const getTermsData = async () => {
    const res = await adminModel.getTermsAndConditions();
    console.log(res)
  
    setTermsContent(res.data.termsAndConditions_File);
   
  }

  useEffect(() => {
    getTermsData();
  },[])

  const handleTermsChange = (content) => {
    setTermsContent(content);
  };

  const handleConditionsChange = (content) => {
    setConditionsContent(content);
  };

  const handleSelectionChange = (range) => {
    if (range) {
      const quill = quillRef.current.getEditor(); 
      const formats = quill.getFormat(range); 
      setCurrentFormats(formats);
    }
  };

  const handleSubmit = async (e) => {
   e.preventDefault();
  const form = new FormData(e.target);
      await adminModel
        .termAndCondition(form)
        .then((res) => {
          if (res) {
            helper.sweetalert.toast("Terms and Conditions updated");
          }
        })
        .catch((error) => {
       
          helper.sweetalert.toast(error?.response?.data?.error, "warning");
        });
  
  };

  return (
    <Container className="pt-7" fluid>
      <Row>
        <Col lg="12" className="mx-auto">
          <Card className="shadow">
            <form onSubmit={handleSubmit}>
            <CardBody>
              <CardHeader className="border-0">
                <h3 className="mb-0">Terms and Conditions</h3>
              </CardHeader>
              {termsContent &&
               <Row className="px-4">
                <Col md="6">
                Updated file</Col>
                <Col md="6">
               <span style={{ textDecoration: "underline", cursor: "pointer", color:"blue" }}> <a href={termsContent} target="_blank" rel="noopener noreferrer" >View</a></span></Col>
              
              </Row>}
              <Row className="px-4">
                <Col md="6">
                Add html file</Col>
                <Col md="6">
                <input type="file" name="termsAndConditions_File" accept=".html,.htm" /></Col>
                {/* <Col md="12">
                  <ReactQuill
                    ref={quillRef}
                    value={termsContent}
                    onChange={handleTermsChange}
                    onChangeSelection={handleSelectionChange} // Triggered on selection changes
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        ["bold", "italic", "underline"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link", "image"],
                        [{ align: [] }],
                        ["clean"],
                      ],
                    }}
                    placeholder="Write the terms here..."
                  />
                </Col>
                <Col md="12">
                  <CardHeader className="border-0">
                    <h3 className="mb-0">Privacy Policies</h3>
                  </CardHeader>
                  <ReactQuill
                    value={conditionsContent}
                    onChange={handleConditionsChange}
                    onChangeSelection={handleSelectionChange}
                    modules={{
                      toolbar: [
                        [{ header: [1, 2, false] }],
                        ["bold", "italic", "underline"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link", "image"],
                        [{ align: [] }],
                        ["clean"],
                      ],
                    }}
                    placeholder="Write the conditions here..."
                  />
                </Col> */}
              </Row>
              
              <Button color="primary" className="mt-4" type="submit">
                Save
              </Button>
            </CardBody></form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default TermsAndConditionsPage;
